import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["draggable"]
const _hoisted_2 = {
  key: 1,
  class: "flex items-center gap-sm q-mt-auto"
}
const _hoisted_3 = { class: "flex-1 fs-13px fw-500" }
const _hoisted_4 = { class: "fs-11px fw-500 text-cool-gray-100 q-mb-none" }

import { computed, ref } from 'vue'

interface IEmits {
  (event: 'update:model-value', data: null | string | number | Array<string | number>): void
  (event: 'menu'): void
  (event: 'dragover', data: { id: number | string }): void
  (event: 'dragstart', data: { id: number | string }): void
  (event: 'dragend'): void
}

interface IProps {
  size?: 'lg' | 'sm'
  status?: string
  title: string
  modelValue: null | string | number | Array<string | number>
  value: string | number
  disable?: boolean
  count?: number
  countTitle?: string
  hasActions?: boolean
  badgeTitle?: string
  badgeType?: 'error' | 'pause'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KCategoryCard',
  props: {
    size: { default: 'lg' },
    status: { default: '#1361D4' },
    title: {},
    modelValue: {},
    value: {},
    disable: { type: Boolean, default: false },
    count: { default: 0 },
    countTitle: { default: 'Items' },
    hasActions: { type: Boolean, default: true },
    badgeTitle: { default: '' },
    badgeType: { default: 'error' }
  },
  emits: ["update:model-value", "menu", "dragover", "dragstart", "dragend"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const isHoveredRef = ref(false)

const emit = __emit

const isSelected = computed(() => {
  if (Array.isArray(props.modelValue)) return props.modelValue.findIndex((item) => item === props.value) !== -1
  return props.modelValue === props.value
})

const state = computed(() => {
  if (props.disable) return 'disable'
  else if (isSelected.value) return 'selected'
  else if (isHoveredRef.value) return 'hover'
  return 'default'
})

function handleClick() {
  if (props.disable) return
  if (Array.isArray(props.modelValue)) {
    let newModelValue = [...props.modelValue]
    if (!isSelected.value) newModelValue.push(props.value)
    else newModelValue = newModelValue.filter((item) => item !== props.value)

    emit('update:model-value', newModelValue)
  } else {
    if (!isSelected.value) emit('update:model-value', props.value)
    else emit('update:model-value', null)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_KCircleIcon = _resolveComponent("KCircleIcon")!
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["k-category-card relative-position", {
      'k-category-card--sm': __props.size === 'sm',
      'k-category-card--disable': __props.disable,
    }]),
    draggable: __props.hasActions,
    "data-testid": "k-category-card",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (isHoveredRef.value = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isHoveredRef.value = false)),
    onClick: handleClick,
    onDragover: _cache[3] || (_cache[3] = ($event: any) => (__props.hasActions && _ctx.$emit('dragover', { id: __props.value }))),
    onDragstart: _cache[4] || (_cache[4] = ($event: any) => (__props.hasActions && _ctx.$emit('dragstart', { id: __props.value }))),
    onDragend: _cache[5] || (_cache[5] = ($event: any) => (__props.hasActions && _ctx.$emit('dragend')))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["rounded-16 k-category-card__box", {
        'k-category-card__box--hovered': isHoveredRef.value && !__props.disable,
        'k-category-card__box--selected': isSelected.value && !__props.disable,
        'k-category-card__box--disable': __props.disable,
      }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["k-category-card__white-box bg-static-light shadow-1 rounded-12 absolute", {
          'k-category-card__white-box--hovered': isHoveredRef.value && !__props.disable,
          'k-category-card__white-box--selected': isSelected.value && !__props.disable,
        }])
      }, null, 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["k-category-card__white-box k-category-card__white-box-rotated bg-static-light shadow-1 rounded-12 absolute", {
          'k-category-card__white-box-rotated--hovered': isHoveredRef.value && !__props.disable,
          'k-category-card__white-box-rotated--selected': isSelected.value && !__props.disable,
        }])
      }, null, 2 /* CLASS */)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["k-category-card__main no-wrap column", [
        __props.size === 'lg' ? 'q-px-12 q-pb-12' : 'q-px-12 q-pb-sm',
        {
          'k-category-card__main--hovered': isHoveredRef.value,
          'k-category-card__main--selected': isSelected.value,
          'k-category-card__main--disable': __props.disable,
        },
      ]])
    }, [
      _createVNode(_component_KIcon, {
        class: "k-category-card__main-icon",
        name: `category-card-${__props.size}-${state.value}`,
        "auto-height": ""
      }, null, 8 /* PROPS */, ["name"]),
      (!__props.disable)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "k-category-card__status rounded-12 absolute",
            style: _normalizeStyle(`background-color:  ${__props.status}`)
          }, null, 4 /* STYLE */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["k-category-card__title-wrapper flex", {
          'column items-start flex-1 gap-xs': __props.size === 'sm',
          'gap-sm items-center q-mb-xs': __props.size !== 'sm',
          'q-mt-sm':__props.size !== 'sm' && __props.title?.length > 23
        }])
      }, [
        (_ctx.$slots['before-title'])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["flex inline k-category-card__asset justify-center items-center", { 'k-category-card__asset--disable': __props.disable }])
            }, [
              _renderSlot(_ctx.$slots, "before-title")
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("p", {
          class: _normalizeClass(["fs-13px fw-600 q-mb-none k-category-card__title", [
            !__props.disable ? 'text-cool-gray-100' : 'text-cool-gray-60',
            { 'q-mt-auto k-category-card__title--small': __props.size === 'sm' },
          ]])
        }, _toDisplayString(__props.title), 3 /* TEXT, CLASS */)
      ], 2 /* CLASS */),
      (__props.size !== 'sm')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.hasActions)
              ? (_openBlock(), _createBlock(_component_KIcon, {
                  key: 0,
                  name: "arrangement",
                  size: "24px",
                  color: "cool-gray-70",
                  class: "cursor-grab"
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                class: _normalizeClass(["q-mr-xs", !__props.disable ? 'text-cool-gray-80' : 'text-cool-gray-70'])
              }, _toDisplayString(__props.count), 3 /* TEXT, CLASS */),
              _createElementVNode("span", {
                class: _normalizeClass(!__props.disable ? 'text-cool-gray-70' : 'text-cool-gray-70')
              }, _toDisplayString(__props.countTitle), 3 /* TEXT, CLASS */)
            ]),
            (__props.hasActions)
              ? (_openBlock(), _createBlock(_component_KCircleIcon, {
                  key: 1,
                  class: "cursor-pointer",
                  name: "menu-dots",
                  background: "white",
                  size: "20px",
                  color: "cool-gray-70",
                  "is-hover": "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('menu')))
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                  (_ctx.$slots['action'])
                    ? {
                        name: "action",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "action")
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1024 /* DYNAMIC_SLOTS */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    (__props.disable && __props.badgeTitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["k-category-card__badge rounded-16 flex items-center gap-xs bg-white", [`k-category-card__badge--${__props.badgeType}`]])
        }, [
          _createVNode(_component_k_icon, {
            name: __props.badgeType === 'error' ? 'remove-solid' : 'pause',
            size: "16px"
          }, null, 8 /* PROPS */, ["name"]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.badgeTitle), 1 /* TEXT */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})